import { createStore } from 'effector'

export const $DOLBY_ATMOS = createStore('Dolby Atmos')
